import { render, staticRenderFns } from "./achatCommande.vue?vue&type=template&id=0ee38d72&"
import script from "./achatCommande.vue?vue&type=script&lang=js&"
export * from "./achatCommande.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports